import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  const styles = {
    wrapper: {
      minHeight: "var(--app-height, 100vh)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#ffffff",
      padding: "2rem",
      fontFamily: "Segoe UI, Tahoma, sans-serif",
    },
    card: {
      background: "#ffffff",
      borderRadius: 0,
      padding: "3rem 2.5rem",
      maxWidth: "480px",
      width: "100%",
      textAlign: "center",
      border: "1px solid #e5e7eb",
      boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    },
    code: {
      fontSize: "6rem",
      fontWeight: 800,
      margin: 0,
      lineHeight: 1,
      background: "linear-gradient(135deg, #1e3a8a, #3b82f6)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    title: {
      fontSize: "1.5rem",
      margin: "0.75rem 0 0.5rem",
      color: "#1f2937",
    },
    message: {
      color: "#6b7280",
      marginBottom: "2rem",
      lineHeight: 1.5,
    },
    actions: {
      display: "flex",
      gap: "0.75rem",
      justifyContent: "center",
      flexWrap: "wrap",
    },
    btnPrimary: {
      background: "#1e3a8a",
      color: "#fff",
      border: "none",
      padding: "0.65rem 1.25rem",
      borderRadius: 0,
      cursor: "pointer",
      fontWeight: 600,
    },
    btnSecondary: {
      background: "#e5e7eb",
      color: "#1f2937",
      border: "none",
      padding: "0.65rem 1.25rem",
      borderRadius: 0,
      cursor: "pointer",
      fontWeight: 600,
    },
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h1 style={styles.code}>404</h1>
        <h2 style={styles.title}>Page Not Found</h2>
        <p style={styles.message}>
          The page you are looking for doesn't exist or has been moved.
        </p>
        <div style={styles.actions}>
          <button style={styles.btnPrimary} onClick={() => navigate("/home")}>
            Go to Home
          </button>
          <button style={styles.btnSecondary} onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
